import { css } from 'styled-components';
import { map } from '../../breakpoint';
const validPositionValues = [
    'static',
    'relative',
    'absolute',
    'fixed',
    'sticky'
];
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const position = ()=>css`
  ${({ position })=>map(position, (val)=>val !== undefined && css`
          position: ${val};
        `)};

  ${({ top } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(top, (val)=>val !== undefined && css`
          inset-block-start: ${val};
        `)};

  ${({ right } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(right, (val)=>val !== undefined && css`
          inset-inline-end: ${val};
        `)};

  ${({ bottom } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(bottom, (val)=>val !== undefined && css`
          inset-block-end: ${val};
        `)};

  ${({ left } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(left, (val)=>val !== undefined && css`
          inset-inline-start: ${val};
        `)};

  ${({ inset } // eslint-disable-line  @typescript-eslint/no-explicit-any
    )=>map(inset, (val)=>val !== undefined && css`
          inset: ${val};
        `)};
`;

//# sourceMappingURL=position.js.map